import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationDetailsTitle = (props: Props) => {
  const { dressingMode, dressingPortionsTitle, dressingWeightTitle } = props;

  const { formatMessage } = useIntl();

  const titleForPortions = dressingPortionsTitle ?? formatMessage(messages.dressingPortionsTitle); // prettier-ignore
  const titleForWeight = dressingWeightTitle ?? formatMessage(messages.dressingWeightTitle); // prettier-ignore

  return (
    <BodyText sizeMatch={['24']} style={styles.title} bold>
      {dressingMode === 'onTheSide' ? titleForPortions : titleForWeight}
    </BodyText>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  dressingPortionsTitle: {
    defaultMessage: 'Choose your dressing portions and how you would like it served',
    description: 'Customization | Details | Title | Dressing portions',
  },
  dressingWeightTitle: {
    defaultMessage: 'Choose your dressing weight and how you would like it served',
    description: 'Customization | Details | Title | Dressing weight',
  },
});

const styles = StyleSheet.create({
  title: {
    color: theme.colors.BLACK,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  dressingMode: 'onTheSide' | 'mixedIn';
  dressingPortionsTitle?: string;
  dressingWeightTitle?: string;
};
